var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.75 29.168c0 10.355-8.3945 18.75-18.75 18.75s-18.75-8.3945-18.75-18.75 8.3945-18.75 18.75-18.75 18.75 8.3945 18.75 18.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.418 83.332v4.168c0 1.1484-0.93359 2.082-2.0859 2.082h-66.664c-1.1523 0-2.0859-0.93359-2.0859-2.082v-4.168c0-8.2852 3.293-16.234 9.1523-22.098 5.8633-5.8594 13.812-9.1523 22.098-9.1523h8.3359c8.2852 0 16.234 3.293 22.098 9.1523 5.8594 5.8633 9.1523 13.812 9.1523 22.098z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpUser2);
export default __webpack_public_path__ + "static/media/np_user2.92ff8de65cb3cfbc1c509a7433d1f0c7.svg";
export { ForwardRef as ReactComponent };